export type SkeletonListJsxProps = {
  attrs?: SkeletonListAttrs;
};

export enum SkeletonListRowSize {
  Header = `header`,
  Large = `large`,
  Medium = `medium`,
  Small = `small`,
}

export type SkeletonListAttrs = {
  'row-size': SkeletonListRowSize;
  'num-rows': number;
};
